module.exports = __webpack_public_path__ + "static/img/4.f129434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/4.png
// module id = aLEI
// module chunks = 0